<template>
  <div>
    <card titulo="Histórico de Consultas BIB" :loading="loading">
      <template #acoes>
        <small class="text-muted">Banco de Indisponibilidade de Bens — TJ-RJ</small>
      </template>

      <card-table class="table-borderless mb-2" v-if="registros.length > 0">
        <thead>
          <tr>
            <th>Protocolo</th>
            <th>Hash da Consulta BIB</th>
            <th>Data da Consulta</th>
            <th>Gratuito</th>
            <th>Lei 11.441/07</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in registros" :key="row.id">
            <td>
              <a href class="text-primary pointer" @click.prevent="abrirProtocolo(row.protocolo_id)">
                {{ row.protocolo_codigo }}
              </a>
            </td>
            <td class="text-truncate" style="max-width: 250px" :title="row.consulta_bib">{{ row.consulta_bib }}</td>
            <td>{{ row.data_consulta_bib }}</td>
            <td>{{ row.gratuito_bib ? 'Sim' : 'Não' }}</td>
            <td>{{ row.lei_11441_bib || '' }}</td>
          </tr>
        </tbody>
      </card-table>

      <div v-if="!registros.length && !loading" class="alert alert-outline-info">
        Não há consultas BIB registradas para este indicador pessoal
      </div>

      <div v-if="totalRegistros > pageLength" class="d-flex justify-content-between align-items-center px-3 pb-2">
        <small class="text-muted">{{ totalRegistros }} registro(s)</small>
        <div>
          <button class="btn btn-outline-secondary btn-sm mr-1" :disabled="pageNumber <= 1" @click="mudarPagina(pageNumber - 1)">
            <i class="fa fa-chevron-left"></i>
          </button>
          <span class="mx-2">Página {{ pageNumber }} de {{ totalPaginas }}</span>
          <button class="btn btn-outline-secondary btn-sm ml-1" :disabled="pageNumber >= totalPaginas" @click="mudarPagina(pageNumber + 1)">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from "@/components/Layout/components/Card.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness.js";
import FrontBusiness from "@/business/FrontBusiness.js";

export default {
  name: "Bib",
  components: { Card, CardTable },
  props: { pessoa: Object },

  data() {
    return {
      loading: true,
      registros: [],
      totalRegistros: 0,
      pageNumber: 1,
      pageLength: 20,
    }
  },

  computed: {
    totalPaginas() {
      return Math.ceil(this.totalRegistros / this.pageLength);
    }
  },

  async mounted() {
    await this.carregar();
  },

  methods: {
    async carregar() {
      this.loading = true;
      try {
        let result = await IndicadorPessoalBusiness.listarHistoricoBib(
          this.pessoa.indicadorPessoalId, 'data_consulta_bib', 'desc', this.pageNumber, this.pageLength);
        this.registros = result.pagina || [];
        this.totalRegistros = result.quantidade || 0;
      } catch (e) {
        FrontBusiness.showError('', e);
      } finally {
        this.loading = false;
      }
    },

    async mudarPagina(pagina) {
      this.pageNumber = pagina;
      await this.carregar();
    },

    abrirProtocolo(protocoloId) {
      FrontBusiness.redirect(`protocolo/${protocoloId}/geral`);
    }
  }
}
</script>
